import apiService from "./apiService";
import AppConstants from "../appConstants";

class AssetReferenceService {
    getAllAssetReference(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ASSET_REFERENCE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getAssetReferenceDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_ASSET_REFERENCE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerAssetReference(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ASSET_REFERENCE, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteAssetReference(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_ASSET_REFERENCE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_ASSET_REFERENCE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new AssetReferenceService();
